export default __webpack_public_path__ + "static/media/deepLearning.4756a2e8.PNG";